// extracted by mini-css-extract-plugin
export var grayCircle = "_dl-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_dl-1";
export var selectedCircle = "_dl-2";
export var shippingOptionImage = "_dl-3";
export var shippingOptionWidgetPreview = "_dl-4";